import tw, {styled} from 'twin.macro';

const LI = styled.li((props) => [
  tw`
  `,
]);

export default LI;
